import React, { useState, useEffect } from "react";

import FancyBackground from "./FancyBackground";
import DefaultCard from "./DefaultCard";
import RecruiterCard from "./RecruiterCard";
import { Loading } from "./Loading";

import "./App.css";
import { ProjectsCard } from "./ProjectsWrapperCard";

function App() {
  const [authenticatedResources, setAuthenticatedResources] = useState(null);
  const [view, setView] = useState(<></>);
  const [projectsVisible, setProjectsVisible] = useState(false);

  useEffect(() => {
    const queryParameters = new URLSearchParams(window.location.search);
    const token = queryParameters.get("token") || "";
    const deviceWidth = window.innerWidth;
    fetch("https://api.l-uca.com/inform_screenwidth", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token, deviceWidth }),
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (authenticatedResources) return;
    const queryParameters = new URLSearchParams(window.location.search);
    const token = queryParameters.get("token");
    if (!token) {
      setView(<DefaultCard setProjectsVisible={setProjectsVisible} />);
      return;
    }
    setView(<Loading />);
    // Get POST response of whenfin-api.l-uca.com/recruitment/token sending {token: token} as a body
    const attempt_fetch = async () => {
      try {
        const whenfinResponse = await fetch(
          "https://api.l-uca.com/initialize",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ token }),
          }
        );
        // Return if response is not 200
        if (whenfinResponse.status !== 200) {
          setView(<DefaultCard setProjectsVisible={setProjectsVisible} />);
          return;
        }
        const json = await whenfinResponse.json();
        if (!json.headshot) {
          setView(<DefaultCard setProjectsVisible={setProjectsVisible} />);
          return;
        }
        setAuthenticatedResources(json);
      } catch (e) {
        setView(<DefaultCard setProjectsVisible={setProjectsVisible} />);
      }
    };
    attempt_fetch();
  }, []);

  useEffect(() => {
    if (!authenticatedResources) return;
    setTimeout(() => {
      setView(
        <RecruiterCard
          setProjectsVisible={setProjectsVisible}
          authenticatedResources={authenticatedResources}
        />
      );
    }, 750);
  }, [authenticatedResources]);

  return (
    <div className="w-full h-full isolate overflow-hidden bg-gray-900 flex items-center justify-center relative sm:p-12 p-8 overscroll-contain">
      <FancyBackground />
      {projectsVisible ? (
        <ProjectsCard
          setProjectsVisible={setProjectsVisible}
          authenticatedResources={authenticatedResources}
        />
      ) : (
        view
      )}
    </div>
  );
}

export default App;
